'use client';

import { Typography } from '@coolblue-development/freddy';
import { Image } from '@coolblue-development/next-image/client';
import { SelectableBox, SelectableBoxGroup } from '@coolblue-development/next-patterns/client';
import { useTranslation } from '@i18n/useTranslation';
import { useContext } from 'react';

import { ProductTradeInContext } from '../Context';
import { Actions } from '../types';
import SelectorGrid from './ProductSelector/SelectorGrid';

const BRAND_SELECTOR_DEFAULT_QUESTION = 'Van welk merk is je product?';

const BrandSelector = () => {
  const { brandData, selectedBrand, dispatch, handleAnswerChange } =
    useContext(ProductTradeInContext);
  const { t } = useTranslation('webshop.productTradeIn');

  function handleBrandChange(brandName: string, brandKey: string) {
    handleAnswerChange?.({ question: BRAND_SELECTOR_DEFAULT_QUESTION }, brandName);
    dispatch?.({ type: Actions.SET_SELECTED_BRAND, payload: Number(brandKey) });
  }

  return (
    <fieldset>
      <legend>
        <Typography variant='h3' mt={600}>
          {t('brandSelectionPrompt')}
        </Typography>
      </legend>
      <SelectorGrid>
        <SelectableBoxGroup
          name='brandSelectorGroup'
          type='radio'
          spacing='default'
          inputPlacement='hidden'
          value={String(selectedBrand)}
        >
          {brandData &&
            Object.keys(brandData).map(key => {
              const [, brandKey] = key.split('_');
              const brand = brandData[key];

              return (
                brand && (
                  <SelectableBox
                    value={brandKey}
                    key={brandKey}
                    onClick={() => handleBrandChange(brand.name, brandKey)}
                  >
                    {brand.image ? (
                      <Image
                        imageId={brand.image.id}
                        fileCollection='content'
                        width={111}
                        height={22}
                        alt={brand.name}
                        loading='eager'
                        fullWidth
                        background='transparent'
                      />
                    ) : (
                      <Typography component='span' textAlign='center'>
                        {brand.name}
                      </Typography>
                    )}
                  </SelectableBox>
                )
              );
            })}
        </SelectableBoxGroup>
      </SelectorGrid>
    </fieldset>
  );
};

export default BrandSelector;
